import { useView } from 'aurelia-framework';
import { autoinject, transient } from "aurelia-dependency-injection";
import { OnboardingRequestModel } from "../../../../../models/onboarding/onboarding.models";
import { Router } from "aurelia-router";

@autoinject()
@transient()
@useView('views/pages/admin/onboarding/onboarding-request/onboarding-request.html')
export class OnboardingRequestViewModel {

    public selectedTab: string = 'workflow';
    public item: OnboardingRequestModel;
    public onboardingRequestId: number;

    activate(params: any) {
        this.onboardingRequestId = params.id;
    }

    onOnboardingRequestFetched(item: OnboardingRequestModel) {
        this.item = item;
        if (!this.item.isCompleted) {
            this.selectedTab = 'activity-logger';
        }
    }

    constructor(private router: Router) { }

    goBack() {
        return this.router.navigateBack();
    }

    public selectTab(tab: string) {
        this.selectedTab = tab;
    }

}
